import axios from "axios";
import { BACKEND_BASEURL } from "../../../db/baseUrl";
export const API_TABLES = `${BACKEND_BASEURL}api/tables/`;

const createTable = async (tableData) => {
  console.log(tableData);
  const response = await axios.post(API_TABLES + "createTable", tableData);
  return response.data;
};

const getTables = async () => {
  const response = await axios.get(API_TABLES + "getTables");
  return response.data;
};

const updateTable = async (tableData) => {
  const response = await axios.patch(API_TABLES + "updateTable", tableData);
  return response.data;
};
const deleteTable = async (id) => {
  const response = await axios.delete(API_TABLES + "deleteTable/" + id);
  return response.data.message;
};

const attachTable = async (tableNo) => {
  const response = await axios.patch(API_TABLES + "attachTable/" + tableNo);
  return response.data.message;
};
const TableServices = {
  createTable,
  getTables,
  updateTable,
  deleteTable,
  attachTable,
};
export default TableServices;
